import { render, staticRenderFns } from "./NonConformitySign.vue?vue&type=template&id=b2c2ec3a&"
import script from "./NonConformitySign.vue?vue&type=script&lang=js&"
export * from "./NonConformitySign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports